import * as _ from 'lodash'
import { localStorageUser } from '../types'
const isBrowser = typeof window !== `undefined`

export const setUser = (user: localStorageUser) =>
  (window.localStorage.gatsbyUser = JSON.stringify(user))

const getUser = () => {
  if (window.localStorage.gatsbyUser) {
    let user = JSON.parse(window.localStorage.gatsbyUser)
    return user ? user : {}
  }
  return {}
}

export const isLoggedIn = () => {
  if (!isBrowser) return false

  const user = getUser()
  if (user) return !!user.username
}

export const isAdmin = () => {
  if (!isBrowser) return false

  const user = getUser()
  if (_.get(user, 'groups')) {
    if (user) return !!user.groups.includes('Admin')
  }
  return false
}

export const getCurrentUser = () => isBrowser && getUser()

export const logout = (callback: () => void) => {
  if (!isBrowser) return
  setUser({})
  callback()
}
